import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { ISelectOptions } from '../../../components/ui/Select/createSelect.types';

import { IHint, IHintListData } from './types';

export const fetchHintsPageRequest = async ({ page, size, sort, ...body }: IQueryParams): Promise<IHintListData | null> => {
  try {
    const res = await axios.post('api/v1/payment/overall-hints', body, { params: { page, size, sort } });
    return {
      ...res.data,
      content: res.data?.content?.map((hint: IHint) => ({ ...hint, payload: { ...hint.payload, hints: hint.payload.hints || [] } })),
    };
  } catch (error) {
    NotificationManager.error("Can't fetch hints");
    return null;
  }
};

export const createHintRequest = async ({ id, ...data }: Partial<IHint>): Promise<Partial<IHint>> => {
  const res = await axios.put(`api/v1/payment/overall-hints`, data);
  return res.data;
};

export const updateHintRequest = async ({ id, ...data }: Partial<IHint>): Promise<Partial<IHint>> => {
  const res = await axios.post(`api/v1/payment/overall-hints/${id}`, data);
  return res.data;
};

export const fetchCurrenciesRequest = async (): Promise<ISelectOptions[]> => {
  const res = await axios.get(`api/v1/currency-providers/currency-codes`);
  return res.data?.map((currency: string) => ({ value: currency, label: currency }));
};

export const deleteHintRequest = async (id: number): Promise<Partial<IHint>> => {
  const res = await axios.delete(`api/v1/payment/overall-hints/${id}`);
  return res.data;
};
